import { UnitDTO } from "./unit";

export enum WindowStatus {
  OK = "Water- en winddicht, alle ramen kunnen open en sluiten goed af, geen zichtbare schade",
  PARTIAL_OK = "De meeste ramen zijn ok, maar enkele ramen vertonen gebreken",
  NOT_OK = "Overwegend alle ramen vertonen gebreken",
  UNKNOWN = "Nog na te kijken",
}

export enum DoorStatus {
  OK = "Water- en winddicht, alle deuren kunnen open en sluiten goed af met de sleutel, geen zichtbare schade",
  PARTIAL_OK = "De meeste deuren zijn ok, maar enkele deuren vertonen gebreken",
  NOT_OK = "Overwegend alle deuren vertonen gebreken",
  UNKNOWN = "Nog na te kijken",
}

export enum MoistStatus {
  OK = "Geen vochtproblemen of schimmel vast te stellen",
  NOT_OK = "Wel schimmel, vochtproblemen of waterdruppels vast te stellen",
  UNKNOWN = "Nog na te kijken",
}

// export enum CondensingMoistStatus {
//     OK = 'Geen schimmel, vochtigheid of waterdruppels op plafonds, muren of vloeren',
//     NOT_OK = 'Wel schimmel, vochtigheid of waterdruppels op plafonds, muren of vloeren',
//     UNKNOWN = "Nog na te kijken"
// }

// export enum PenetratingMoistStatus {
//     OK = 'Geen (regen)water dat door de muren binnenkomt',
//     NOT_OK = 'Wel (regen)water dat door de muren binnenkomt',
//     UNKNOWN = "Nog na te kijken"
// }

// export enum RisingMoistStatus {
//     OK = 'Geen vochtige plekken, loskomende verf, behang of pleisterwerk onderaan de muren',
//     NOT_OK = 'Wel vochtige plekken, loskomende verf, behang of pleisterwerk onderaan de muren',
//     UNKNOWN = "Nog na te kijken"
// }

// export enum SeepingMoistStatus {
//     OK = 'Geen insijpelend vocht via daken of buitenmuren',
//     NOT_OK = 'Wel insijpelend vocht via daken of buitenmuren',
//     UNKNOWN = "Nog na te kijken"
// }

export enum WindowTerraceSafetyStatus {
  OK = "Veilig terras of borstwering voorzien bij lage ramen",
  NOT_REQUIRED = "Geen terras en geen lage ramen",
  NOT_OK = "Onveilige situatie bij terras en/of lage ramen",
  UNKNOWN = "Nog na te kijken",
}

export enum WallStatus {
  OK = "Goede afwerking, geen barsten of gaten",
  NOT_OK = "Zichtbare slijtage, barsten of gaten",
  UNKNOWN = "Nog na te kijken",
}

export enum FloorStatus {
  OK = "Goede afwerking, geen barsten of gaten",
  PARTIALY_OK = "Kleine slijtage zoals scheurtjes, maar niets ernstigs",
  NOT_OK = "Zichtbare slijtage, barsten of gaten",
  UNKNOWN = "Nog na te kijken",
}

export enum CeilingStatus {
  OK = "Goede afwerking, geen barsten of gaten",
  NOT_OK = "Zichtbare slijtage, barsten of gaten",
  UNKNOWN = "Nog na te kijken",
}

export enum BathroomHealthStatus {
  OK = "Natuurlijk licht en ventilatie mogelijk",
  PARTIAL_OK_LIGHT = "Licht aanwezig, maar geen ventilatie mogelijk",
  PARTIAL_OK_VENTILATION = "Ventilatie mogelijk, maar geen natuurlijk licht",
  NOT_OK = "Geen natuurlijk licht, geen ventilatie mogelijk",
  UNKNOWN = "Nog na te kijken",
}

export enum ToiletHealthStatus {
  OK = "Ventilatie mogelijk",
  NOT_OK = "Geen ventilatie mogelijk",
  UNKNOWN = "Nog na te kijken",
}

export enum BedroomsHealthStatus {
  OK = "Natuurlijk licht en ventilatie mogelijk",
  PARTIAL_OK_LIGHT = "Licht aanwezig, maar geen ventilatie mogelijk",
  PARTIAL_OK_VENTILATION = "Ventilatie mogelijk, maar geen natuurlijk licht",
  NOT_OK = "Geen natuurlijk licht, geen ventilatie mogelijk",
  UNKNOWN = "Nog na te kijken",
}

export type UnitInspectionInfoDTO = {
  id: number;
  unit: UnitDTO;
  unitId: string;
  generalRemarks: string;
  numBedrooms: number;
  numBathrooms: number;
  numToilets: number;
  windowStatus: WindowStatus;
  windowStatusDescription: string;
  doorStatus: DoorStatus;
  doorStatusDescription: string;
  moistStatus: MoistStatus;
  // condensingMoistStatus: CondensingMoistStatus;
  // penetratingMoistStatus: PenetratingMoistStatus;
  // risingMoistStatus: RisingMoistStatus;
  // seepingMoistStatus: SeepingMoistStatus;
  moistStatusDescription: string;
  windowTerraceSafetyStatus: WindowTerraceSafetyStatus;
  windowTerraceSafetyStatusDescription: string;
  wallStatus: WallStatus;
  floorStatus: FloorStatus;
  ceilingStatus: CeilingStatus;
  ceilingHeight: string;
  bathroomHealthStatus: BathroomHealthStatus;
  bedroomsHealthStatus: BedroomsHealthStatus;
  toiletHealthStatus: ToiletHealthStatus;
};
